import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { DefaultEulaComponent } from '../default-eula/default-eula.component';
import { FreeTrialEulaComponent } from '../free-trial-eula/free-trial-eula.component';
import { DeeprootsEulaComponent } from '../deeproots-eula/deeproots-eula.component';
import { AuthService } from '../../../auth/services/auth.service';
import { EulaType } from '../../models/eula';

@Component({
  selector: 'app-license-agreement',
  standalone: true,
  imports: [
    DefaultEulaComponent,
    FreeTrialEulaComponent,
    DeeprootsEulaComponent,
  ],
  templateUrl: './license-agreement.component.html',
  styleUrl: './license-agreement.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class LicenseAgreementComponent implements OnInit {
  private readonly _route = inject(ActivatedRoute);
  private readonly _authService = inject(AuthService);
  private readonly _router = inject(Router);

  private _stateValue: string | null = null;
  auth0RedirectUrl = '';
  isChecked = false;
  scrollProgress = 0;
  eulaToken: string | null = null;
  eulaType: EulaType | null = null;
  isLoading = false;

  ngOnInit(): void {
    this.eulaToken = this._route.snapshot.queryParamMap.get('token');
    if (!this.eulaToken) {
      this._router.navigate(['/error?code=404']);
    }
    this._stateValue = this._route.snapshot.queryParamMap.get('state');
    this.auth0RedirectUrl = `https://${environment.auth.domain}/continue?state=${this._stateValue}`;
    this._getEulaType();
  }

  onScroll(event: Event): void {
    const element = event.target as HTMLElement;
    const scrollTop = element.scrollTop;
    const scrollHeight = element.scrollHeight - element.clientHeight;
    this.scrollProgress = (scrollTop / scrollHeight) * 100;
  }

  private _getEulaType(): void {
    if (this.eulaToken) {
      this.isLoading = true;
      this._authService.getEulaType(this.eulaToken).subscribe({
        next: (eulaType: EulaType) => {
          this.eulaType = eulaType;
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error fetching EULA type:', error);
          this.isLoading = false;
          this._router.navigate(['/error']);
        },
      });
    }
  }
}
